import { createContext, useContext, useState, useEffect } from "react";
import api from "@/lib/api";

const CurrencyContext = createContext(null);

const SYMBOLS = { EUR: "\u20ac", USD: "$", CAD: "CA$" };
const FALLBACK = { EUR: 1.0, USD: 1.10, CAD: 1.48 };

export function CurrencyProvider({ children }) {
    const [currency, setCurrencyState] = useState(
        () => localStorage.getItem("gtc_currency") || "USD"
    );
    const [rates, setRates] = useState(FALLBACK);

    useEffect(() => {
        api.get("/fx-rates")
            .then(r => setRates(r.data?.rates || FALLBACK))
            .catch(() => setRates(FALLBACK));
    }, []);

    const setCurrency = (c) => {
        setCurrencyState(c);
        localStorage.setItem("gtc_currency", c);
    };

    // amountEur -> converted number in active currency
    const convert = (amountEur) =>
        Number(amountEur || 0) * (rates[currency] || 1);

    // amountEur -> formatted string with symbol, e.g. "$12.13"
    const fmt = (amountEur) =>
        `${SYMBOLS[currency]}${convert(amountEur).toFixed(2)}`;

    return (
        <CurrencyContext.Provider
            value={{ currency, setCurrency, rates, convert, fmt, symbol: SYMBOLS[currency] }}>
            {children}
        </CurrencyContext.Provider>
    );
}

export function useCurrency() {
    const ctx = useContext(CurrencyContext);
    if (!ctx) throw new Error("useCurrency must be used within CurrencyProvider");
    return ctx;
}
